var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{attrs:{"width":"100%","height":"100%","src":"https://tte.palmco.id","frameborder":"0","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }